import React from 'react'
import {AdminNavigation} from '@modifi/ui'
import {clientConfig} from '@modifi/client-config'

import {ROUTE_NAMES} from '../../routes/constants'

const riskOfficeUrl = clientConfig.get('SERVICE_RISK_OFFICE')

const Header = () => (
  <AdminNavigation
    logoItem={{
      to: ROUTE_NAMES.INDEX,
    }}
    appType="RISK_ONBOARDING"
    menuItems={[
      {
        label: 'Tasks',
        to: ROUTE_NAMES.TASKS,
      },
      {
        label: 'Onboarding',
        to: `${clientConfig.get('SERVICE_ACTIVATIONS')}${ROUTE_NAMES.ACTIVATION}`,
        subMenus: [
          {
            label: 'Companies',
            to: `${clientConfig.get('SERVICE_ACTIVATIONS')}${ROUTE_NAMES.ACTIVATION}`,
          },
          {
            label: 'BSR list',
            to: `${clientConfig.get('SERVICE_ACTIVATIONS')}${ROUTE_NAMES.BSR_LIST}`,
          },
        ],
      },
      {
        label: 'Customers',
        to: `${riskOfficeUrl}/companies`,
        isExternal: true,
      },
      {
        label: 'Orders',
        to: `${riskOfficeUrl}/orders`,
        isExternal: true,
      },
      {
        label: 'Payments',
        to: `${riskOfficeUrl}/funds-transfers`,
        isExternal: true,
      },
      {
        label: 'Billing',
        to: `${riskOfficeUrl}/invoices`,
        isExternal: true,
      },
      {
        label: 'Match',
        to: clientConfig.get('SERVICE_MATCHING_TOOL') as string,
        isExternal: true,
      },
    ]}
  />
)

export default Header
